import type { LessonCompletionMigration } from '@/lib/sync'
import { useSyncStore } from '@/stores/SyncStore'

type SyncModuleOptions = {
  syncIntervalSec?: number
}

export const useSyncModule = (options: SyncModuleOptions = {}) => {
  const syncStore = useSyncStore()

  if (Object.keys(options).length > 0) {
    syncStore.configure(options)
  } else {
    syncStore.ensureService()
  }

  // WP-106 Rollout
  // TODO: Remove this flag after control group removal
  const isSyncProtocolActive = true

  const initSyncModule = async () => {
    await syncStore.initCompletion()
  }

  const startSyncModule = () => {
    syncStore.startSyncing()
  }

  const migrateCompletedLessons = (lessons: LessonCompletionMigration[]) => {
    return syncStore.migrateCompletedLessons(lessons)
  }

  const stopSyncModule = () => {
    syncStore.stopSyncing()
    syncStore.stopListening()
  }

  return {
    syncStore,
    isSyncProtocolActive,
    initSyncModule,
    startSyncModule,
    migrateCompletedLessons,
    stopSyncModule
  }
}
